import { CREATE_STUDENT_FEEDBACK, CREATING_STUDENT_FEEDBACK, DELETE_STUDENT_FEEDBACK, DELETING_STUDENT_FEEDBACK, GET_STUDENT_FEEDBACK, GETTING_STUDENT_FEEDBACK, STUDENT_FEEDBACK_ERROR, UPDATE_STUDENT_FEEDBACK, UPDATING_STUDENT_FEEDBACK } from "../types"

const initialState = {
    studentFeedback: [],
    loadingStudentFeedback: true,
    studentFeedbackError: null,
    creatingStudentFeedback: false,
    createdStudentFeedback: null,
    updatingStudentFeedback: false,
    updatedStudentFeedback: null,
    deletingStudentFeedback: false,
    deletedStudentFeedback: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_STUDENT_FEEDBACK:
        return {
            ...state,
            creatingStudentFeedback :action.payload,
        }
        case CREATE_STUDENT_FEEDBACK:
        return{
            ...state,
            creatingStudentFeedback:false,
            subjectsError:  null,
            createdStudentFeedback: action.payload,
        }
        case UPDATING_STUDENT_FEEDBACK:
        return {
            ...state,
            updatingStudentFeedback :action.payload,
        }
        case UPDATE_STUDENT_FEEDBACK:
        return{
            ...state,
            updatingStudentFeedback:false,
            subjectsError:  null,
            updatedStudentFeedback: action.payload,
        }
        case DELETING_STUDENT_FEEDBACK:
        return {
            ...state,
            deletingStudentFeedback :action.payload,
        }
        case DELETE_STUDENT_FEEDBACK:
        return{
            ...state,
            deletingStudentFeedback:false,
            subjectsError:  null,
            deletedStudentFeedback: action.payload,
        }
        case GETTING_STUDENT_FEEDBACK:
        return {
            ...state,
            loadingStudentFeedback :action.payload,
        }
        case GET_STUDENT_FEEDBACK:
        return{
            ...state,
            loadingStudentFeedback:false,
            studentFeedback: action.payload,
        }
        case STUDENT_FEEDBACK_ERROR:
        return{
            ...state,
            loadingStudentFeedback:false,
            creatingStudentFeedback: false,
            updatingStudentFeedback: false,
            studentFeedbackError: action.payload 
        }
        default: return state
    }

}